import api from "./api";

export const categoriesService = {
  getAll: async (
    page = 1,
    limit = 10,
    search = "",
    sortBy = "name",
    sortOrder = "asc",
  ) => {
    const response = await api.get("/api/admin/categories", {
      params: { page, limit, search, sortBy, sortOrder },
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/api/admin/categories/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post("/api/admin/categories", data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.patch(`/api/admin/categories/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/api/admin/categories/${id}`);
    return response.data;
  },
};
